import * as React from "react";
import {
  FormattedMessage,
  WrappedComponentProps,
  injectIntl,
} from "react-intl";
import { PostLikeFeatureButton } from "@vingle/wtf-sdk/components/featureButtons";
import { IconWrapper } from "common/icons";
import PACKS from "common/icons/packs";
import NumberFormatter from "@vingle/wtf-sdk/components/numberFormatter";
import { LottieLikeEffect } from "common/components/lottieLikeControl";
import { ActionCreators as DialogActionCreators } from "app/vingleDialog/actions";

const styles = require("./postLike.scss");

interface IProps extends WrappedComponentProps {
  postId: Vingle.Id;
  likedState: boolean;
  likeCount: number;
  onClick?: () => void;
}

interface IState {
  isInHover: boolean;
}

class PostLikeTextIconButton extends React.PureComponent<IProps, IState> {
  public state: IState = {
    isInHover: false,
  };

  public render() {
    const { postId, likedState, onClick, intl } = this.props;
    const title = intl.formatMessage({ id: "like" });
    return (
      <PostLikeFeatureButton
        postId={postId}
        likedState={likedState}
        unsignedUserAction={DialogActionCreators.openSignUpDialog}
        className={styles.textIconButton}
        style={{
          height: 24,
        }}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={onClick}
        title={title}
      >
        {this.renderInner()}
      </PostLikeFeatureButton>
    );
  }

  private readonly renderInner = () => {
    const { likeCount, likedState } = this.props;
    const baseIcon = likedState
      ? PACKS.ENGAGE.CARD_DECK_LIKE_ACTIVE
      : PACKS.ENGAGE.CARD_DECK_LIKE_NORMAL;

    return (
      <>
        <span className={styles.iconWrapper}>
          <IconWrapper tagName="span" icon={baseIcon} className={styles.icon} />
          <span className={styles.likeLottie}>
            <LottieLikeEffect liked={likedState} likeCount={likeCount} />
          </span>
        </span>

        <span className={styles.engageCount}>
          {Boolean(likeCount) ? (
            <NumberFormatter num={likeCount} digits={0} />
          ) : (
            <FormattedMessage id="like" />
          )}
        </span>
      </>
    );
  };

  private readonly changeIsInHoverState = (state: boolean) => {
    if (this.state.isInHover !== state) {
      this.setState({
        isInHover: state,
      });
    }
  };

  private readonly handleMouseEnter = () => {
    this.changeIsInHoverState(true);
  };

  private readonly handleMouseLeave = () => {
    this.changeIsInHoverState(false);
  };
}

export default injectIntl(PostLikeTextIconButton);
